import { useState } from 'react';

export default function Configuration() {
  const configurationExists = localStorage.getItem("OPENAI_API_KEY") != null && localStorage.getItem("FIRECRAWL_API_KEY") != null;
  const [showConfiguration, setShowConfiguration] = useState(!configurationExists);
  const [openAIAPIKey, setOpenAIAPIKey] = useState(localStorage.getItem("OPENAI_API_KEY"));
  const [firecrawlAPIKey, setFirecrawlAPIKey] = useState(localStorage.getItem("FIRECRAWL_API_KEY"));
  const [showOpenAIKey] = useState(openAIAPIKey === null || openAIAPIKey === "");
  const [showFirecrawlKey] = useState(firecrawlAPIKey === null || firecrawlAPIKey === "");


  function addConfiguration() {
    if (openAIAPIKey && firecrawlAPIKey) {
      localStorage.setItem("OPENAI_API_KEY", openAIAPIKey);
      localStorage.setItem("FIRECRAWL_API_KEY", firecrawlAPIKey);
      console.log("Configuration updated");
      setShowConfiguration(false);
    }
  }

  return (
    <>
      {showConfiguration && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 text-black">
          <div className="flex flex-col bg-white p-6 rounded shadow-lg gap-y-5 w-3/4">
            <h2 className="text-xl font-bold mb-4">Configure @note</h2>
            {showOpenAIKey && (
              <div className='flex items-center gap-x-2'>
                <div className="">OPENAI_API_KEY:</div>
                <input onChange={(e) => setOpenAIAPIKey(e.target.value)} type="text" className="border border-gray-300 rounded w-full p-2" />
              </div>
            )}
            {showFirecrawlKey && (
              <div className='flex items-center gap-x-2'>
                <div className="">FIRECRAWL_API_KEY:</div>
                <input onChange={(e) => setFirecrawlAPIKey(e.target.value)} type="text" className="border border-gray-300 rounded w-full p-2" />
              </div>
            )}
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded"
              onClick={() => addConfiguration()}
            >
              Confirm
            </button>
          </div>
        </div>)}
    </>
  );
};